import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SignupStepOneComponent } from './signup-step-one.component';
import { ComponentsModule } from 'src/app/components/components.module';


@NgModule({
  declarations: [
    SignupStepOneComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class SignupStepOneModule {}